import { useTranslation } from "react-i18next"

interface NoMessageProps {
  name: string
}
export default function NoMessage({ name }: NoMessageProps) {
  const { t } = useTranslation()
  return (
    <h2 className="fw-bolder text-center mt-3">{`${t("noMessages.no")} ${name}`}</h2>
  )
}
